import React, { } from "react";
import useIntersectionObserver from "./home-animation";
export default function HomeRightEmployer() {
    const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <div className="home-connecting home-right-emp mt-0">
            <div className="home-connecting-overlay"></div>
            <div className="outer-container">
                <div className="home-counter-row position-relative">
                    <div className={`home-counter-div home-employe-div ${isVisible1 ? 'animate__fadeIn' : ''}`} style={{ animationDuration: '1.25s' }} ref={sectionRef1}>
                    <div className="connecting-head">Connecting Employers with the Perfect Candidates</div>
                        <p className="main-para text-white connecting-para">Discover skilled professionals who fit seamlessly into your organization. Streamline your hiring process with our comprehensive recruitment solutions.</p>
                        {/* <button type="button" className="home-page-btn1">Get Started</button> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
